import React, { Component, Fragment } from 'react';
import { MdClose } from 'react-icons/md';
import { connect } from 'react-redux';
import { firebaseConnect } from 'react-redux-firebase';
import { compose } from 'redux';
import {
  Button,
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  Form,
  FormGroup,
  FormInput,
  FormSelect,
  InputGroup,
  InputGroupAddon
} from 'shards-react';
import {
  addCategory,
  addSectors,
  addSubCategories,
  deleteItem
} from '../adminActions';

const mapState = (state, ownProps) => ({
  user: state.firebase.profile,
  sector: ownProps.sector || '',
  dbsectors: state.firebase.ordered.sectors,
  categories: state.firebase.ordered.categories,
  subsectors: state.firebase.ordered.subsectors,
  subcategories: state.firebase.ordered.subcategories
});

const actions = {
  addSectors,
  deleteItem,
  addCategory,
  addSubCategories
};

class AddSubCategories extends Component {
  state = {
    sector: '',
    category: '',
    input: ''
  };

  handleSector = async e => {
    e.preventDefault();
    //console.log(e.target.value);

    if (e.target.name === 'category') {
      this.setState({ [e.target.name]: JSON.parse(e.target.value) });
    } else {
      this.setState({ [e.target.name]: e.target.value });
    }
    //this.props.firestore.get({ collection: 'sectors', doc: e.target.value, storeAs: 'queried' });
    //console.log(this.props.sectors);
  };

  render() {
    const handleChange = e => {
      if (e.target.name === 'category') {
        this.setState({
          [e.target.name]: JSON.parse(e.target.value).toLowerCase()
        });
      }
      this.setState({ [e.target.name]: e.target.value.toLowerCase() });
    };
    const handleSubmit = e => {
      e.preventDefault();

      //console.log(this.state.category);
      let subcategory = {
        sector: this.state.category.sector,
        category: this.state.category.name,
        name: this.state.input
      };

      this.props.addSubCategories(subcategory);

      this.setState({ input: '' });
    };

    const { subcategories, categories, deleteItem } = this.props;
    return (
      <Card>
        <CardHeader className='bg-primary1 text-white'>
          Sub Categories
        </CardHeader>
        <CardBody className='category-list'>
          {subcategories &&
            subcategories.map(category => {
              return (
                <div
                  key={category.key}
                  className='text-capitalize w-100 caption'
                >
                  {category.value.sector} - {category.value.name}
                  <MdClose
                    className='float-right text-danger'
                    onClick={() => deleteItem('subcategories/', category.key)}
                  >
                    Delete
                  </MdClose>
                </div>
              );
            })}
        </CardBody>
        <CardFooter className='border-top'>
          <Form>
            <FormGroup>
              <label htmlFor='category'>Select Category</label>
              <FormSelect
                name='category'
                onChange={e => this.handleSector(e)}
                value={JSON.stringify(this.state.category)}
              >
                <option key='0' value='' />
                {categories &&
                  categories.map(sector => (
                    <Fragment>
                      <option
                        key={sector.key}
                        value={JSON.stringify(sector.value)}
                      >
                        {sector.value.sector} - {sector.value.name}
                      </option>
                    </Fragment>
                  ))}
              </FormSelect>
            </FormGroup>

            <FormGroup>
              <InputGroup>
                <FormInput
                  name='input'
                  placeholder='Type a subcategory here'
                  onChange={handleChange}
                  value={this.state.input}
                />
                <InputGroupAddon type='append'>
                  <Button
                    theme='success'
                    onClick={handleSubmit}
                    disabled={this.state.category === ''}
                  >
                    Submit
                  </Button>
                </InputGroupAddon>
              </InputGroup>
            </FormGroup>
          </Form>
        </CardFooter>
      </Card>
    );
  }
}

export default compose(
  connect(mapState, actions),
  firebaseConnect([
    {
      path: '/subcategories',
      queryParams: ['orderByChild=sector'],
      storeAs: 'subcategories'
    }
  ])
)(AddSubCategories);
